require('jquery-validation');
require('./jquery-validation-init');
require('jquery-validation-unobtrusive');
require('./custom-validators');